export default __webpack_public_path__ + "static/media/Death.3880fcc6.png";